import React from 'react'
import URL from './URL'
import { isAfter, subDays } from 'date-fns'
const today = new Date()

const PageListTitle = (props) => (
    <>
        <strong>
            {props.title}
            {(props.lastmod && isAfter(new Date(props.lastmod), subDays(today, 30)) && <span className="badge badge-danger ml-1">NEW</span>) || null}
        </strong>
        <br />
        {(props.url && (
            <small>
                <URL {...props} link={true} />
            </small>
        )) ||
            null}
    </>
)

export default PageListTitle
